import { fabric } from 'fabric';
import { Blob } from 'blob-polyfill';
import { sendToMixPanel } from '@/_utilities/seerMixPanel';
import { MIXPANEL_EVENTS } from '@/_utilities/Enums';

export default {
  methods: {
    rightClickMenuItems(useless) {
      // Show items corresponding to current active object
      if (this.canvas == null) {
        return [];
      }
      const active = this.canvas.getActiveObject();
      //   const isText = (element) => element && element.get('type') === 'i-text';
      const isImage = active && active.get('type') === 'image';

      this.checkClipboardHasImage();
      const options = [{
        name: 'Copy',
        icon: 'move-to-back',
        show: () => active,
        action: () => {
          this.copyFabricObject();
        },
      },
      {
        name: 'Paste',
        icon: 'paste',
        show: (element) => {
          // isIPad comes from whichbrowser mixin
          // navigator.clipboard is not supported on iPad but we are using a localstorage workaround
          if (this.isIPad) {
            return true;
          }

          const SUPPORTED_BROWSERS = ['chrome', 'safari'];
          const useragent = navigator.userAgent.toLowerCase();
          //  Browser is supported and provides required method
          return SUPPORTED_BROWSERS.filter((browser) => useragent.includes(browser)).length
            && navigator.clipboard && navigator.clipboard.read;
        },
        action: () => {
          // isIPad comes from whichbrowser mixin
          if (this.isIPad) {
            this.pasteFromLocalstorage();
            return;
          }

          this.paste(this.pointer);
        },
      },
      {
        name: 'Add link',
        icon: 'add-link',
        show: () => isImage,
        action: () => {
          this.$refs.addLink.open();
        },
      },
      {
        name: 'Link Text',
        icon: 'add-link',
        show: (element) => false, // Disabled for now
        action: () => {
          //   this.next_select = (text) => {
          //     if (this.canvas.getActiveObject().get('type') !== 'i-text') { }
          //   };
        },
      },
      ];
      return options.filter((option) => option.show(active));
    },
    paste(pointer = { x: 0, y: 0 }) {
      sendToMixPanel(MIXPANEL_EVENTS.addImage, {
        source: ' copy_paste',
        location: 'collage',
      });
      // Paste normal image
      this.triggerPaste();
      // Paste fabric Object
      this.pasteFabricObject(this, this.canvas, pointer);

      this.$nextTick().then(() => {
        this.canvas.fire('mouse:down');
      });
    },
    pasteFabricObject: async (vm) => {
      const data = await navigator.clipboard.read();

      data.forEach((element) => {
        if (element.types.includes('text/plain')) {
          const blob = element.getType('text/plain');
          blob.then((r) => r.text().then((text) => {
            try {
              vm.createFabricObjectFromData(text);
            } catch (e) {
              console.log('Error creating object', e);
            }
          }));
        }
      });
    },
    pasteFromLocalstorage() {
      const clipboard = localStorage.getItem('clipboard');
      if (clipboard) {
        this.createFabricObjectFromData(clipboard);
      }
    },
    createFabricObjectFromData(data) {
      const { canvas, pointer } = this;

      const setPosition = (fabricElement) => {
        canvas.add(fabricElement);
        fabricElement.top = (pointer.y === 0) ? fabricElement.top + 10 : pointer.y;
        fabricElement.left = (pointer.x === 0) ? fabricElement.left + 10 : pointer.x;
        fabricElement.iscloned = true; // With this tag we should know if is copied or new
        fabricElement.setCoords();
        canvas.setActiveObject(fabricElement);
        canvas.renderAll();
      };

      try {
        const fabricObject = JSON.parse(data);

        // Images
        if (fabricObject.type === 'image') {
          fabric.Image.fromObject(fabricObject, (fabricImage) => {
            setPosition(fabricImage);
          });
        }

        // Text
        if (fabricObject.type === 'i-text') {
          fabric.IText.fromObject(fabricObject, (fabricText) => {
            setPosition(fabricText);
          });
        }
        if (fabricObject.type === 'textbox') {
          fabric.Textbox.fromObject(fabricObject, (fabricTextbox) => {
            setPosition(fabricTextbox);
          });
        }
      } catch (e) {
        if (e.toString().includes('is not valid JSON') && !this.showLinkModal && !this.addImageIsOpen) {
          this.$refs.tools.$refs.texttool.addText(data);
        }
      }
    },
    copyFabricObject() {
      if (this.canvas.getActiveObject().isEditing) {
        return;
      }
      const currentObject = JSON.parse(JSON.stringify(this.currentObject));
      if (this.currentObject.meta) {
        currentObject.meta = { site_url: this.currentObject.meta.site_url };
      }
      const element = JSON.stringify(currentObject);

      // Ipad clipboard workaround
      if (this.isIPad) {
        localStorage.setItem('clipboard', element);
        return;
      }
      const blob = new Blob([element], { type: 'text/plain' });
      this.setToClipboard(blob);
    },
    setToClipboard: async (blob) => {
      // eslint-disable-next-line no-undef
      const data = [new ClipboardItem({ [blob.type]: blob })];
      await navigator.clipboard.write(data);
    },
    askWritePermission: async () => {
      try {
        // The clipboard-write permission is granted automatically to pages
        // when they are the active tab. So it's not required, but it's more safe.
        const { state } = await navigator.permissions.query({ name: 'clipboard-write' });
        return state === 'granted';
      } catch (error) {
        // Browser compatibility / Security error (ONLY HTTPS) ...
        return false;
      }
    },
  },
};
